import RadioButtonGroup from '../../../Common/RadioButtonGroup/RadioButtonGroup';
import React from 'react';
import Selector from '../../../../types/report/Selector';
import SelectOption from '../../../../infrastructure/types/SelectOption';

interface Props {
    options: Selector[];
    value: number | null;
    onChange: (value: string) => void;
}

class IsinsSetBuilder extends React.Component<Props> {

    getOptions(): SelectOption[] {
        const selectOptions: SelectOption[] = this.props.options.map((isinSelector) => {

            return {
                text: isinSelector.name,
                value: isinSelector.number.toString(),
            };
        });

        return selectOptions;
    }

    render(): JSX.Element {

        return (
            <div className="mt-3">
                <RadioButtonGroup
                    className='display-flex flex-wrap'
                    options={this.getOptions()}
                    name="isin-selectors-options"
                    value={(this.props.value === null || this.props.value === undefined) ? this.props.options[0].number.toString() : this.props.value.toString()}
                    onChange={this.props.onChange} />
            </div>
        );
    }
}

export default IsinsSetBuilder;
